import { MmcDataSource } from '../index';
import { configs } from '../configs';
import { memoizeWithAllArgsHashed as memoize } from '../utils';

const entityFactory = {
  promotion: memoize((storeId, promotionDetailId) =>
    new MmcDataSource({
      routePrefix: configs.routes.oDataRoute,
      entityName: '',
      endpoint: configs.endpoints.promotions(storeId),
      idAttribute: promotionDetailId,
    })),
  markets: memoize(storeId =>
    new MmcDataSource({
      routePrefix: configs.routes.oDataRoute,
      entityName: '',
      endpoint: configs.endpoints.getMarkets(storeId),
    })),
  pilotFeatures: memoize(storeId =>
    new MmcDataSource({
      routePrefix: configs.routes.oDataRoute,
      entityName: '',
      endpoint: configs.endpoints.getPilotFeatures(storeId),
    })),
  promotionTypes: () =>
    new MmcDataSource({
      routePrefix: configs.routes.oDataRoute,
      entityName: '',
      endpoint: configs.endpoints.getPromotionTypes,
    }),
  getStorage: memoize(storeId =>
    new MmcDataSource({
      routePrefix: configs.routes.oDataRoute,
      entityName: '',
      endpoint: configs.endpoints.getPromotionStorage(storeId),
    })),
  stopPromotions: memoize(storeId =>
    new MmcDataSource({
      routePrefix: configs.routes.oDataRoute,
      entityName: '',
      endpoint: configs.endpoints.stopPromotion(storeId),
    })),
  retestPromotions: memoize(storeId =>
    new MmcDataSource({
      routePrefix: configs.routes.oDataRoute,
      entityName: '',
      endpoint: configs.endpoints.retestPromotion(storeId),
    })),
  uploadPromotion: memoize(storeId =>
    new MmcDataSource({
      routePrefix: configs.routes.oDataRoute,
      entityName: '',
      endpoint: configs.endpoints.uploadPromotionFeed(storeId),
    })),
};

export const promotionQueries = {
  gridDataSource(storeId) {
    const entity = entityFactory.promotion(storeId);

    return {
      type: 'jsdata',
      entity,
      primaryKey: 'Id',
      query: {
        $expand: 'promotionrejections',
      },
    };
  },
  getPromotions(storeId, customQueryParams, options) {
    const entity = entityFactory.promotion(storeId);

    return entity.findAll(customQueryParams, options);
  },
  getPromotionDetails(storeId, promotionDetailId) {
    const entity = entityFactory.promotion(storeId, promotionDetailId);

    return entity.find(promotionDetailId);
  },
  getPromotionMarkets(storeId) {
    const entity = entityFactory.markets(storeId);

    return entity.findAll();
  },
  getPromotionTypes() {
    const entity = entityFactory.promotionTypes();

    return entity.findAll();
  },
  createPromotion(storeId, payload) {
    const entity = entityFactory.promotion(storeId);

    return entity.create(payload);
  },
  updatePromotion(storeId, promotionDetailId, payload) {
    const entity = entityFactory.promotion(storeId);

    return entity.update(promotionDetailId, payload);
  },
  getUploadLink(storeId) {
    const entity = entityFactory.getStorage(storeId);

    return entity.find();
  },
  uploadPromotion(storeId, payload) {
    const entity = entityFactory.uploadPromotion(storeId);

    return entity.create(payload);
  },
  stopPromotions(storeId, promotionDetailIds) {
    const entity = entityFactory.stopPromotions(storeId);

    return entity.create(promotionDetailIds);
  },
  retestPromotions(storeId, promotionDetailIds) {
    const entity = entityFactory.retestPromotions(storeId);

    return entity.create(promotionDetailIds);
  },
  getPilotFeatures(storeId) {
    const entity = entityFactory.pilotFeatures(storeId);

    return entity.find(null, {
      expand: ['customerflags', 'storepilotfeatures'],
    });
  },
};
